import { AffiliateModel } from '../../../../models/dashboard/marketplace/affiliatesModel';
import { adminHttpClient } from "../../../../commons/adminHttpClinet";


const deletePlatform = (id:string): Promise<any> => {
    return adminHttpClient.delete(`/api/Admin/AdminMarketplace/delete-platform?Id=${id}`, null)
}
export default deletePlatform;

